import React, { createContext, useState } from "react";
import axios from "axios";

function findMost(array) {
  if (array.length === 0) return null;
  let modeMap = {};
  let maxEl = array[0],
    maxCount = 1;
  for (let i = 0; i < array.length; i++) {
    let el = array[i];
    if (modeMap[el] == null) modeMap[el] = 1;
    else modeMap[el]++;
    if (modeMap[el] > maxCount) {
      maxEl = el;
      maxCount = modeMap[el];
    }
  }
  if (maxCount > 1) {
    return maxEl;
  } else return null;
}

export const AutoCatContext = createContext();

export const AutoCatProvider = ({ children }) => {
  const [sugTag, setSugTag] = useState([]);
  const [sugCat, setSugCat] = useState([]);
  const [load, setLoad] = useState([false, false]);
  const fetchPos = async (content) => {
    const result = await axios.get("https://api.aiforthai.in.th/tpos", {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Apikey: "bXagwMODVlCkp1fxJm7jyZjwy22D81G5",
      },
      params: {
        text: content.slice(0, 615).replace(/%/g, "Percent"),
      },
    });
    const aiData = result.data;
    const nnWord = [];
    if (aiData) {
      for (let i = 0; i < aiData.words.length; i++) {
        if (aiData.tags[i] === "NN") {
          nnWord.push(aiData.words[i]);
        }
      }
    }
    const res = findMost(nnWord);
    if (res && res !== "วัน") {
      setSugCat(res);
    }
    setLoad([false, load[1]]);
  };

  const fetchTag = async (content) => {
    const result = await axios.get(
      "https://api.aiforthai.in.th/tagsuggestion",
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Apikey: "bXagwMODVlCkp1fxJm7jyZjwy22D81G5",
        },
        params: {
          text: content.slice(0, 615).replace(/%/g, "Percent"),
          numtag: "4",
        },
      }
    );
    const aiData = result.data;
    const aiTags = aiData["tags"].map((e) => e.tag);
    setSugTag(aiTags);
    setLoad([load[0], false]);
  };

  const autoCat = (memo) => {
    setLoad([true, true]);
    fetchPos(memo);
    fetchTag(memo);
  };

  return (
    <AutoCatContext.Provider value={{ autoCat, sugTag, sugCat, load }}>
      {children}
    </AutoCatContext.Provider>
  );
};
